var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSilverRank4(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#silver_rank_4_svg__clip0_1947_6767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "silver_rank_4_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 198
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.865.332H0v197.196h200.865V.332z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#silver_rank_4_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.334 38.435c-5.344-5.579-14.62-4.129-18.037 2.784-8.93 18.047-6.153 40.468 8.615 55.888 18.43 19.241 48.732 20.482 68.68 3.192L37.333 38.435z",
    fill: "#DCDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 75.59C6.903 73.358-.439 79.17.024 86.857c1.201 20.079 14.761 38.208 35.265 44.369 25.585 7.687 52.553-6.103 61.308-30.929L14.322 75.589z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 121.52c-7.507 1.916-10.76 10.668-6.358 17.004 11.497 16.557 32.546 25.082 53.291 19.795 25.89-6.598 41.771-32.28 36.315-58.02l-42.55 10.843-40.704 10.372.006.006z",
    fill: "#D2D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 38.435c5.344-5.579 14.621-4.129 18.037 2.784 8.931 18.047 6.153 40.468-8.614 55.888-18.43 19.241-48.732 20.482-68.68 3.192l59.257-61.864z",
    fill: "#DCDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.543 75.59c7.419-2.23 14.762 3.581 14.305 11.274-1.202 20.08-14.762 38.208-35.266 44.37-25.585 7.687-52.553-6.103-61.308-30.929l82.269-24.715z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 121.52c7.507 1.916 10.759 10.668 6.358 17.004-11.497 16.557-32.547 25.082-53.291 19.795-25.89-6.598-41.77-32.28-36.315-58.02l42.55 10.843 40.704 10.372-.006.006z",
    fill: "#D2D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792.332h108.224c6.47 0 11.72 5.218 11.72 11.647v120.122c0 36.106-29.499 65.422-65.832 65.422-36.332 0-65.832-29.316-65.832-65.422V11.979c0-6.43 5.25-11.647 11.72-11.647z",
    fill: "#CDCBCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.195 67.483h75.413c4.506 0 8.169 3.634 8.169 8.118v49.098c0 25.164-20.557 45.587-45.873 45.587-25.321 0-45.872-20.429-45.872-45.587V75.601c0-4.478 3.657-8.118 8.169-8.118h-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 69.812c3.211 0 5.825 2.598 5.825 5.789v49.098c0 23.853-19.526 43.257-43.529 43.257-24.002 0-43.528-19.404-43.528-43.257V75.601c0-3.191 2.613-5.789 5.825-5.789h75.413m0-2.33h-75.42c-4.511 0-8.168 3.635-8.168 8.119v49.098c0 25.175 20.54 45.587 45.872 45.587 25.333 0 45.873-20.412 45.873-45.587V75.601c0-4.484-3.657-8.118-8.169-8.118h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.016.332h-44.982L35.072 74.827v51.322l125.3-124.524a11.72 11.72 0 00-5.356-1.293zM95.712 111.969l71.024-70.581V12.305L81.079 97.428l14.633 14.541z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.223 23.335l2.033 6.22a1.677 1.677 0 001.6 1.153h6.581c1.629 0 2.303 2.067.984 3.016l-5.321 3.844a1.666 1.666 0 00-.609 1.863l2.033 6.22c.504 1.537-1.265 2.818-2.584 1.863l-5.321-3.843a1.688 1.688 0 00-1.975 0l-5.32 3.843c-1.319.95-3.089-.326-2.585-1.863l2.034-6.22a1.667 1.667 0 00-.61-1.863l-5.32-3.844c-1.32-.949-.64-3.016.984-3.016h6.58c.727 0 1.372-.466 1.6-1.153l2.034-6.22c.504-1.537 2.69-1.537 3.194 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.223 23.335l2.033 6.22a1.677 1.677 0 001.6 1.153h6.581c1.629 0 2.303 2.067.984 3.016l-5.32 3.844a1.665 1.665 0 00-.61 1.863l2.033 6.22c.504 1.537-1.265 2.818-2.584 1.863l-5.321-3.843a1.688 1.688 0 00-1.975 0l-5.32 3.843c-1.319.95-3.089-.326-2.585-1.863l2.034-6.22a1.667 1.667 0 00-.61-1.863l-5.32-3.844c-1.32-.949-.64-3.016.984-3.016h6.58c.727 0 1.372-.466 1.6-1.153l2.034-6.22c.504-1.537 2.69-1.537 3.194 0h-.012z",
    fill: "#FEE066"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "silver_rank_4_svg__clip0_1947_6767"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h201v198H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverRank4);
export default ForwardRef;